// extracted by mini-css-extract-plugin
module.exports = {"TextInputDelay":"TextInputDelay_TextInputDelay__B5Jqn"};